import ForgotPasswordComponent from "../components/forgot-password/forgot-password.component";


const ForgotPassword = () => {

    return (
        <>
            <ForgotPasswordComponent></ForgotPasswordComponent>
        </>
    )

}

export default ForgotPassword;